<div class="position-relative">
  <div class="container d-xs-flex align-items-xs-center min-height-xs-100vh">
    <div class="row pt-10 pb-2 px-5" style="text-align: center;">
      <h1>Our Charity Efforts</h1>
    </div>
    <div class="container px-lg-7">
      <div class="row my-4">
        <div class="col-12 p-3 transparent-card">
          <p class="mainBody">
              Tanzania remains to be one of the most impoverished countries in the world.
              Roughly 50% of the population lives below the poverty line. In addition, education
              enrollment rates tend to drop to merely 30% by the time kids reach secondary education. We’re here to change this.
          </p>
          <br/>
          <p class="mainBody">
            Kopa Tours works directly with Zara Charity and its affiliates.
            15% of every purchase is donated directly into the charity program. Through this program,
            funding goes to help support 4 separate charities and organizations.
          </p>
        </div>
      </div>
    </div>

    <!-- Mockup Block -->
    <div class="container">
      <div class="row align-items-lg-center">
        <div id="preschool" class="col-lg-5 mb-7 mb-lg-0">
          <!-- Title -->
          <div class="pr-lg-4">
            <span class="btn btn-icon btn-soft-secondary text-fg-alt rounded-circle mb-3">
              <span class="small font-weight-bold btn-icon__inner">01.</span>
            </span>
            <h2 class="h4 font-weight-semi-bold text-fg">Preschool Projects</h2>
            <p class="mb-0">It is not uncommon for children in Tanzania to travel more than an hour or two to school each and every morning. This long commute is strenuous on them, and is one of many reasons that the education enrollment numbers are alarmingly low throughout Tanzania.
                It is our mission to provide easily accessible school for all students. Currently, we have succeeded in completing the structure of two separate preschools. Both of these preschools are in the Ngorongoro Area, which has previously not offered conveniently located schools. Between these two schools, we currently have 96 children enrolled.

                With your donations, we help fund each child’s education. One child’s yearly education costs roughly $150, which includes school fees, uniforms, meals, and educational supplies. With your help, we can educate the youth of Tanzania, and help raise them out of poverty through the power of education.
            </p>
          </div>
          <!-- End Title -->
        </div>

        <div id="svgPreschool" class="col-lg-7 jpg-preloader">
          <!-- SVG Icon -->
          <figure class="ie-marketing-strategy">
            <img class="container img-cont" appWidth=700 appHeight=450 appLazyload="others/preschool-project.jpg" alt="Kopa Tours preschool project"
                 data-parent="#SVGappDevelopment">
          </figure>
          <!-- End SVG Icon -->
        </div>
      </div>
    </div>
    <!-- End Mockup Block -->

    <!-- Mockup Block -->
    <div class="container space-top-1 space-top-md-0">
      <div class="row align-items-lg-center">
        <div id="womens-group" class="col-lg-5 order-lg-2 mb-7 mb-lg-0">
          <!-- Title -->
          <div class="pl-lg-4">
            <span class="btn btn-icon btn-soft-secondary text-fg-alt rounded-circle mb-3">
              <span class="small font-weight-bold btn-icon__inner">02.</span>
            </span>
            <h2 class="h4 font-weight-semi-bold text-fg">The Maasai Women’s Group</h2>
            <p class="mb-0">The Masaai women live a beautiful, simple life with their families in villages. However, as times change their need for monetary support grows as they strive to continue their same way of life. We recognize this and want to support them in a way that still allows them to be true to themselves. Maasai Women are expert craft and jewelry makers. With this skill, they hand make beaded jewelry and come to sell their products on our properties to tourists like yourself. With their profits, they are able to provide food, educational supplies, and the basic necessities of life for their families back home. The Maasai Women work hard in their business to provide exceptional souvenirs for you. So, please consider purchasing directly from them on your upcoming trip rather than the large gift shops and help support giving back to the community in a healthy, supportive manner. </p>
          </div>
          <!-- End Title -->
        </div>

        <div id="svgMaasaiWomen" class="col-lg-7 jpg-preloader">
          <!-- SVG Icon -->
          <figure class="ie-marketing-strategy">
            <img class="container img-cont" appWidth=700 appHeight=450 appLazyload="others/maasai-women.jpg" alt="Maasai women dancing"
                 data-parent="#SVGappDevelopment">
          </figure>
          <!-- End SVG Icon -->
        </div>
      </div>
    </div>
    <!-- End Mockup Block -->

    <!-- Mockup Block -->
    <div class="container space-1">
      <div class="row align-items-lg-center">
        <div id="tree-planting" class="col-lg-5 mb-7 mb-lg-0">
          <!-- Title -->
          <div class="pr-lg-4">
            <span class="btn btn-icon btn-soft-secondary text-fg-alt rounded-circle mb-3">
              <span class="small font-weight-bold btn-icon__inner">03.</span>
            </span>
            <h2 class="h4 font-weight-semi-bold text-fg">Tree Planting Project</h2>
            <p class="mb-0">As a strong advocate for Sustainable Tourism Development, we are glad to offer both a project and an experience that promotes responsible tourism. We offer you the opportunity to make a direct difference by planting a tree after you complete your Kilimanjaro trek. Tanzania is lucky enough to have one of the world's largest tree covers. However, this is quickly becoming a threatened statistic due to an excessive amount of deforestation. When you partake in this Tree Planting Project, you will be rewarded by having a direct and long lasting impact on the community and world at large. </p>
          </div>
          <!-- End Title -->
        </div>

        <div id="svgTreePlanting" class="col-lg-7 jpg-preloader">
          <!-- SVG Icon -->
          <figure class="ie-marketing-strategy">
            <img class="container img-cont" appWidth=700 appHeight=450 appLazyload="others/tree-planting-project.jpg" alt="A group of people holding up potted plants"
                 data-parent="#SVGappDevelopment">
          </figure>
          <!-- End SVG Icon -->

        </div>
      </div>
    </div>
    <!-- End Mockup Block -->

    <!-- Mockup Block -->
    <div class="container space-top-2 space-bottom-2 space-bottom-md-3">
      <div class="row align-items-lg-center">
        <div class="col-lg-5 order-lg-2 mb-7 mb-lg-0">
          <!-- Title -->
          <div class="pl-lg-4">
            <span class="btn btn-icon btn-soft-secondary text-fg-alt rounded-circle mb-3">
              <span class="small font-weight-bold btn-icon__inner">04.</span>
            </span>
            <h2 class="h4 font-weight-semi-bold text-fg">Mount Kilimanjaro Porters Society</h2>
            <p class="mb-0">Porters work extremely hard to provide the best service and experience for you when you come to climb Mount Kilimanjaro,
              and we want to provide the same exceptional support for them as well. Please read more on our <u><a class="light-link" routerLink="/helpful-information/porters-society">Porter's Society</a></u> page.</p>
          </div>
          <!-- End Title -->
        </div>

        <div id="svgColorfulPorters" class="col-lg-7 jpg-preloader">
          <!-- SVG Icon -->
          <figure class="ie-marketing-strategy">
            <img class="container img-cont" appWidth=960 appHeight=638 appLazyload="others/colorful-porters-posing.jpg" alt="Porters lined up along a path"
                 data-parent="#SVGappDevelopment">
          </figure>
          <!-- End SVG Icon -->
        </div>
      </div>
    </div>
    <!-- End Mockup Block -->
  </div>
</div>
